import {useQuery} from 'react-query';
import getStoreSaleAgentList from '.';

const useGetStoreSaleAgentList = (store_guid?: string) => {
  const {data, isLoading} = useQuery(
    ['get-store-sale-agent-list', store_guid],
    () => getStoreSaleAgentList({store_guid}),
  );

  return {
    storeSaleAgentList: data,
    storeSaleAgentListIsLoading: isLoading,
  };
};

export default useGetStoreSaleAgentList;
